import React, { useEffect, useRef } from "react";
import classes from "./Ratio.module.css";
import image from "../../../assets/images/academics-ratio.jpg";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const Ratio = (props) => {
  gsap.registerPlugin(ScrollTrigger);

  const overlayRef = useRef(null);

  useEffect(() => {
    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: overlayRef.current,
        start: "top 50%",
      },
    });

    timeline.to(overlayRef.current, { opacity: 1, duration: 1, ease: "sine.out" });
  });

  return (
    <div className={classes.Ratio}>
      <img src={image} alt="Professor and Student" />
      <div ref={overlayRef} className={classes.Overlay}>
        <div className={classes.Content}>
          <div className={classes.ContentItem}>
            <span>9:1</span> STUDENT-FACULTY RATIO
          </div>
        </div>
      </div>
    </div>
  );
};

export default Ratio;
